import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * AvailableDatesApi - axios parameter creator
 * @export
 */
const AvailableDatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} [productIds]
         * @param {String} [givenDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateEstimatedDelivery: async (productIds, givenDate, options = {}) => {
            const localVarPath = `/v1/AvailableDates/CalculateEstimatedDelivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productIds) {
                localVarQueryParameter['productIds'] = productIds;
            }
            if (givenDate !== undefined) {
                localVarQueryParameter['givenDate'] = (givenDate instanceof Date) ?
                    givenDate.toISOString() :
                    givenDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExceptionDay: async (id, options = {}) => {
            const localVarPath = `/v1/AvailableDates/DeleteExceptionDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkCalendar: async (id, options = {}) => {
            const localVarPath = `/v1/AvailableDates/DeleteWorkCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkDay: async (id, options = {}) => {
            const localVarPath = `/v1/AvailableDates/DeleteWorkDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionDaysById: async (id, options = {}) => {
            const localVarPath = `/v1/AvailableDates/GetExceptionDaysById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCalendars: async (options = {}) => {
            const localVarPath = `/v1/AvailableDates/GetWorkCalendars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkDaysById: async (id, options = {}) => {
            const localVarPath = `/v1/AvailableDates/GetWorkDaysById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertExceptionDays: async (ExceptionDayToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/InsertExceptionDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ExceptionDayToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWorkCalendar: async (WorkCalendarToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/InsertWorkCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(WorkCalendarToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWorkDays: async (WorkDayToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/InsertWorkDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(WorkDayToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExceptionDays: async (ExceptionDayToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/UpdateExceptionDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ExceptionDayToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkCalendar: async (WorkCalendarToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/UpdateWorkCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(WorkCalendarToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkDays: async (WorkDayToken, options = {}) => {
            const localVarPath = `/v1/AvailableDates/UpdateWorkDays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(WorkDayToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AvailableDatesApi - functional programming interface
 * @export
 */
const AvailableDatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AvailableDatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Array<number>} [productIds]
         * @param {String} [givenDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateEstimatedDelivery(productIds, givenDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateEstimatedDelivery(productIds, givenDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.calculateEstimatedDelivery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExceptionDay(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExceptionDay(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.deleteExceptionDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkCalendar(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkCalendar(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.deleteWorkCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkDay(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkDay(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.deleteWorkDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExceptionDaysById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExceptionDaysById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.getExceptionDaysById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkCalendars(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkCalendars(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.getWorkCalendars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkDaysById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkDaysById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.getWorkDaysById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertExceptionDays(ExceptionDayToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertExceptionDays(ExceptionDayToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.insertExceptionDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertWorkCalendar(WorkCalendarToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertWorkCalendar(WorkCalendarToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.insertWorkCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertWorkDays(WorkDayToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertWorkDays(WorkDayToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.insertWorkDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExceptionDays(ExceptionDayToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExceptionDays(ExceptionDayToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.updateExceptionDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkCalendar(WorkCalendarToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkCalendar(WorkCalendarToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.updateWorkCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkDays(WorkDayToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkDays(WorkDayToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableDatesApi.updateWorkDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AvailableDatesApi - factory interface
 * @export
 */
const AvailableDatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AvailableDatesApiFp(configuration);
    return {
        /**
         *
         * @param {Array<number>} [productIds]
         * @param {String} [givenDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateEstimatedDelivery(productIds, givenDate, options) {
            return localVarFp.calculateEstimatedDelivery(productIds, givenDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExceptionDay(id, options) {
            return localVarFp.deleteExceptionDay(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkCalendar(id, options) {
            return localVarFp.deleteWorkCalendar(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkDay(id, options) {
            return localVarFp.deleteWorkDay(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionDaysById(id, options) {
            return localVarFp.getExceptionDaysById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkCalendars(options) {
            return localVarFp.getWorkCalendars(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkDaysById(id, options) {
            return localVarFp.getWorkDaysById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertExceptionDays(ExceptionDayToken, options) {
            return localVarFp.insertExceptionDays(ExceptionDayToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWorkCalendar(WorkCalendarToken, options) {
            return localVarFp.insertWorkCalendar(WorkCalendarToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWorkDays(WorkDayToken, options) {
            return localVarFp.insertWorkDays(WorkDayToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ExceptionDayToken} [ExceptionDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExceptionDays(ExceptionDayToken, options) {
            return localVarFp.updateExceptionDays(ExceptionDayToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkCalendarToken} [WorkCalendarToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkCalendar(WorkCalendarToken, options) {
            return localVarFp.updateWorkCalendar(WorkCalendarToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {WorkDayToken} [WorkDayToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkDays(WorkDayToken, options) {
            return localVarFp.updateWorkDays(WorkDayToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AvailableDatesApi - object-oriented interface
 * @export
 * @class AvailableDatesApi
 * @extends {BaseAPI}
 */
class AvailableDatesApi extends BaseAPI {
    /**
     *
     * @param {Array<number>} [productIds]
     * @param {String} [givenDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    calculateEstimatedDelivery(productIds, givenDate, options) {
        return AvailableDatesApiFp(this.configuration).calculateEstimatedDelivery(productIds, givenDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    deleteExceptionDay(id, options) {
        return AvailableDatesApiFp(this.configuration).deleteExceptionDay(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    deleteWorkCalendar(id, options) {
        return AvailableDatesApiFp(this.configuration).deleteWorkCalendar(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    deleteWorkDay(id, options) {
        return AvailableDatesApiFp(this.configuration).deleteWorkDay(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    getExceptionDaysById(id, options) {
        return AvailableDatesApiFp(this.configuration).getExceptionDaysById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    getWorkCalendars(options) {
        return AvailableDatesApiFp(this.configuration).getWorkCalendars(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    getWorkDaysById(id, options) {
        return AvailableDatesApiFp(this.configuration).getWorkDaysById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ExceptionDayToken} [ExceptionDayToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    insertExceptionDays(ExceptionDayToken, options) {
        return AvailableDatesApiFp(this.configuration).insertExceptionDays(ExceptionDayToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {WorkCalendarToken} [WorkCalendarToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    insertWorkCalendar(WorkCalendarToken, options) {
        return AvailableDatesApiFp(this.configuration).insertWorkCalendar(WorkCalendarToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {WorkDayToken} [WorkDayToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    insertWorkDays(WorkDayToken, options) {
        return AvailableDatesApiFp(this.configuration).insertWorkDays(WorkDayToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ExceptionDayToken} [ExceptionDayToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    updateExceptionDays(ExceptionDayToken, options) {
        return AvailableDatesApiFp(this.configuration).updateExceptionDays(ExceptionDayToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {WorkCalendarToken} [WorkCalendarToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    updateWorkCalendar(WorkCalendarToken, options) {
        return AvailableDatesApiFp(this.configuration).updateWorkCalendar(WorkCalendarToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {WorkDayToken} [WorkDayToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableDatesApi
     */
    updateWorkDays(WorkDayToken, options) {
        return AvailableDatesApiFp(this.configuration).updateWorkDays(WorkDayToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { AvailableDatesApi, AvailableDatesApiAxiosParamCreator, AvailableDatesApiFactory, AvailableDatesApiFp };
//# sourceMappingURL=available-dates-api.js.map
